import { TaskItem } from '@/entities/tasks/model/types'

export const mockSteamOnTasks: TaskItem[] = [
  {
    id: 11,
    is_counter: false,
    kind: 1,
    name: 'addSteam',
    next_claim_available: '2025-04-15T10:16:28.470454Z',
    payload: {},
    pinned: true,
    repeatable: false,
    reward: 0,
    status: 0,
    variant: 'completion',
    currentCount: 0,
    maxCount: 1,
  },
  {
    id: 11,
    is_counter: false,
    kind: 1,
    name: 'addEpic',
    next_claim_available: '2025-04-15T10:16:28.470454Z',
    payload: {},
    pinned: true,
    repeatable: false,
    reward: 0,
    status: 0,
    variant: 'completion',
    currentCount: 0,
    maxCount: 1,
  },

  // {
  //   id: 37,
  //   is_counter: false,
  //   kind: 1,
  //   name: 'xPost',
  //   next_claim_available: null,
  //   payload: {
  //     url_cis: 'https://x.com/gamedonton',
  //     url: 'https://x.com/gamedonton',
  //   },
  //   pinned: false,
  //   repeatable: false,
  //   reward: 0,
  //   status: 0,
  //   variant: 'completion',
  //   currentCount: 0,
  //   maxCount: 0,
  // },
  {
    id: 4,
    is_counter: false,
    kind: 1,
    name: 'openSteamOn',
    next_claim_available: null,
    payload: {},
    pinned: false,
    repeatable: false,
    reward: 0,
    status: 0,
    variant: 'completion',
    currentCount: 0,
    maxCount: 0,
  },
  {
    id: 5,
    is_counter: false,
    kind: 1,
    name: 'openPs5',
    next_claim_available: null,
    payload: {},
    pinned: false,
    repeatable: false,
    reward: 0,
    status: 0,
    variant: 'completion',
    currentCount: 0,
    maxCount: 0,
  },
  {
    id: 33,
    is_counter: false,
    kind: 1,
    name: 'x',
    next_claim_available: '2025-04-15T10:16:34.175740Z',
    payload: {
      url_cis: 'https://x.com/gamedonton',
      url: 'https://x.com/gamedonton',
    },
    pinned: false,
    repeatable: false,
    reward: 0,
    status: 0,
    variant: 'completion',
    currentCount: 0,
    maxCount: 1,
  },
]
